<script setup lang="ts">
  import { differenceInDays } from 'date-fns'

  defineProps<{
    createdAt: string,
  }>()
</script>

<template>
  <span
    class="text-xs ml-1 text-primary-500"
    :class="{'hidden': differenceInDays(new Date(), createdAt) >= 1}">
    NEW
  </span>
</template>
